export default "__VITE_ASSET__dYl$8GMr__"